// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 5730 ? "44530001" : chunkId) + "-" + {"5730":"4c43e402a41c8493","9686":"bd9e6e49577c21d3","9818":"578fa4986dd706e0"}[chunkId] + ".js";
};